import './Steps.css';

import { Progress } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import ImgActiveStep1 from '../../assets/images/base/step1-r.png';
import ImgDeactiveStep1 from '../../assets/images/base/step1-w.png';
import ImgActiveStep2 from '../../assets/images/base/step2-r.png';
import ImgDeactiveStep2 from '../../assets/images/base/step2-w.png';
import ImgActiveStep3 from '../../assets/images/base/step3-r.png';
import ImgDeactiveStep3 from '../../assets/images/base/step3-w.png';

const Steps = ({ className = '', step }) => {
  const StepsList = [
    {
      step: 1,
      active_image: ImgActiveStep1,
      deactive_image: ImgDeactiveStep1,
      name: 'سبد خرید'
    },
    {
      step: 2,
      active_image: ImgActiveStep2,
      deactive_image: ImgDeactiveStep2,
      name: 'انتخاب شیوه ارسال'
    },
    {
      step: 3,
      active_image: ImgActiveStep3,
      deactive_image: ImgDeactiveStep3,
      name: 'پرداخت'
    }
  ];

  return (
    <div className={`steps-container ${className}`}>
      <div className="helbest-steps-wraper">
        {StepsList.map((data_item, data_item_index) => (
          <React.Fragment key={`sb-${data_item_index}`}>
            <span
              key={`sb-${data_item_index}`}
              className={`step-box ${data_item.step <= step ? 'step-box-active' : ''}`}>
              <img
                alt={data_item.name}
                src={data_item.step <= step ? data_item.active_image : data_item.deactive_image}
              />
              <span>{data_item.name}</span>
            </span>
            {data_item_index < Number(StepsList.length) - 1 ? (
              <span key={`sc-${data_item_index}`} className="step-connector" />
            ) : null}
          </React.Fragment>
        ))}
      </div>
      <Progress
        className="helbest-steps-line"
        percent={50 * (step - 1)}
        showInfo={false}
        status="active"
        strokeColor={{ from: '#1a0848', to: '#1a0848' }}
        strokeLinecap="round"
        trailColor="505050"
      />
    </div>
  );
};

Steps.propTypes = {
  step: PropTypes.number || PropTypes.string,
  className: PropTypes.string
};

export default Steps;
